import React from 'react';

import { Auth, API } from 'aws-amplify'

import AuthCard from './AuthCard';

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import Button from '@material-ui/core/Button'

class UsernameHandler extends React.Component {
    state = {
        loading: false,
        username: ''
    }
    handleInputChange = e => {
        this.setState({ username: e.target.value.toLowerCase().trim() });
    }

    handleSubmit = e => {
        e.preventDefault();
        const { username } = this.state;
        this.setState({ loading: true }, () =>
            API.put('AnnalectDatalakeApi', '/auth-check', {
                body: { username }
            }).then(data => {
                if (data.exists) {
                    if (data.enabled) {
                        switch (data.status) {
                            case "UNCONFIRMED":
                                break;
                            case "ARCHIVED":
                                break;
                            case "COMPROMISED":
                                break;
                            case "RESET_REQUIRED":
                                break;
                            case "FORCE_CHANGE_PASSWORD":
                                this.props.onStateChange('temp_password_required', { username });
                                // change state enter password
                                break;
                            case "USER_MIGRATION_REQUIRED":
                                // this.props.onStateChange('user_migration_required', { username });
                                Auth.signIn(username, data.migrationToken).then(user => {
                                    if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                                        this.props.onStateChange('new_password_required', { user });
                                    } else {
                                        this.props.onStateChange('user_signin_complete');
                                    }
                                }).catch(signInErr => {
                                    // this.setState({ helpText: signInErr.message, helpTextClass: 'error', loading: false })
                                });
                                break;
                            case "UNKNOWN":
                                break;
                            default: // CONFIRMED
                                // change state enter password
                                this.props.onStateChange('password_required', { username });
                                break;
                        }
                    } else {
                        //User not enabled
                    }
                } else {
                    if (data.allowed) {

                        this.props.onStateChange('self_signup_required', { username });
                    }
                    else {
                        let ccEmail = data.domainContact;
                        this.props.onStateChange('self_signup_prohibited', {
                            username, errorType: 'Self signup prohibited', ccEmail,
                            helpText: 'Self sign up is not permitted for this email address, please contact support to request an account'
                        });
                    }
                }
            }).catch(err => {
                // this.setState({ authMessages: { message: err.message, details: JSON.stringify(err) } });
                console.log(err);
            }));
    }

    render() {
        const { loading, username } = this.state;
        return (
            <form onSubmit={this.handleSubmit}>
                <AuthCard loading={loading} {...this.props} title="Log in to Connect" subheader="Enter your email to start">
                    <Grid container spacing={24}>
                        <Grid item xs>
                            <TextField
                                id="login_username" name="login_username" autoComplete="off" value={username}
                                placeholder="Email Address" fullWidth autoFocus disabled={loading}
                                onChange={this.handleInputChange}
                                margin="normal"
                            />
                        </Grid>
                        <Grid item>
                            <FormControl margin="normal">
                                <Button variant="contained" color="primary" disabled={loading} onClick={this.handleSubmit}>Go</Button>
                            </FormControl>
                        </Grid>

                    </Grid>
                </AuthCard>
            </form>
        )
    }
}
export default UsernameHandler;


// WEBPACK FOOTER //
// ./src/Components/Authentication/AuthParts/UsernameHandler.js